import { DashboardLayout } from "@/components/dashboard/dashboard-layout";
import ArchivedClientList from "./ArchivedClientList";

export default function ArchivedClientsPage() {
  return (
    <DashboardLayout activeTab="clients">
      <ArchivedClientList />
    </DashboardLayout>
  );
}
